// sessionActivity.js
// Lets any component report user activity to useSessionTimeout without
// prop-drilling — needed because some "the user is clearly using the app"
// states generate no observable DOM event on `window` at all. The clearest
// case: a case/document preview renders the file in a cross-origin <iframe>
// (Firebase Storage is a different origin than app hosting), so scrolling
// or clicking inside the iframe fires events in the iframe's own document,
// which never bubble (or are even visible) to the parent window — the idle
// timer would otherwise count a user actively reading a long PDF as idle
// and log them out mid-document.
export const SESSION_ACTIVITY_EVENT = 'firmassist:activity';

export function pingSessionActivity() {
  window.dispatchEvent(new Event(SESSION_ACTIVITY_EVENT));
}
